import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsBowlingRestaurant } from '../../store/setupApi';
import './css/accountFrozenOverlay.css';

const translations = {
  nl: {
    title: 'Account bevroren',
    message: 'Uw account is bevroren wegens een openstaande factuur. Neem contact met ons op om dit op te lossen.',
    contactUs: 'Contacteer ons',
  },
  en: {
    title: 'Account frozen',
    message: 'Your account has been frozen due to an outstanding payment. Please contact us to resolve this.',
    contactUs: 'Contact us',
  },
  fr: {
    title: 'Compte gelé',
    message: 'Votre compte a été gelé en raison d\'un paiement impayé. Veuillez nous contacter pour résoudre ce problème.',
    contactUs: 'Contactez-nous',
  },
};

export default function AccountFrozenOverlay() {
  const isBowling = useSelector(selectIsBowlingRestaurant);
  const lang = localStorage.getItem('preferredLanguage') || 'nl';
  const t = translations[lang] || translations.nl;

  const logo = isBowling
    ? 'https://static.reservaties.net/images/logo/HappyBowlingFinal.png'
    : 'https://static.reservaties.net/images/logo/HappyChef.png';

  return (
    <div className="account-frozen-overlay">
      <div className="account-frozen-overlay__card">
        <img src={logo} alt="Logo" className="account-frozen-overlay__logo" />
        <h1 className="account-frozen-overlay__title">{t.title}</h1>
        <p className="account-frozen-overlay__message">{t.message}</p>
        <a
          className="account-frozen-overlay__button"
          href="mailto:info@happychef.be"
        >
          {t.contactUs}
        </a>
      </div>
    </div>
  );
}
